import { SignUp } from '@clerk/clerk-react';
import styles from './login-styles.module.css';

export function SignupPage() {
  return (
    <div className={styles['signup-page']}>
      <SignUp />
    </div>
  );
}
